import { defineMessages } from 'react-intl';

export default defineMessages({
  txName: 'Faucet',
  caption: `Faucet {currencySymbol}`,
  boxTitle: 'Faucet',
  boxDescription: 'Please submit to faucet',
  successButtonTitle: 'Go to deposit',
  rowTitle: 'Currency to faucet',
  pageTitle: `Faucet {currencySymbol}`,
  connectWallet: 'Please connect a wallet',
  connectWalletDescription: 'We couldn’t detect a wallet. Connect a wallet to faucet.',
});
